import { initPosthogDeferred } from "config/posthog-runtime";
import { ENVS } from "config/envs";
import { hasAdsConsent } from "lib/analytics/consent";
import { ensureOpenAiAdsPixel } from "lib/analytics/openai-ads-pixel";
import { persistAcquisitionAttributionFromUrl } from "utils/readAcquisitionAttribution";

export const activateProductAnalytics = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  persistAcquisitionAttributionFromUrl();
  // With regional consent on, the ads pixel waits for ads consent (denied under GPC).
  if (!ENVS.regionalConsent || hasAdsConsent()) {
    ensureOpenAiAdsPixel();
  }
  void initPosthogDeferred();
};
